import * as ReqType from '../types/ServerRequests';
import Axios, { AxiosResponse } from 'axios';
import LoginServices from './LoginServices';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des types d'evenement
 */
export class TypeEventService {
    private static instance: TypeEventService = new TypeEventService();

    public static getInstance(): TypeEventService {
        return this.instance;
    }

    /**
     * retourne une liste de type d'evenements
     * @returns {Promise<TypeEvent[]>}
     */
    public getTypes(): Promise<ReqType.TypeEvent[]> {
        const token = LoginServices.getInstance().getUserToken();
        return (
            Axios.get(
                process.env.REACT_APP_TYPE_EVENT_LIST_URL!,
                {
                    headers: { 'X-Access-Token': token },
                }
            ).then(
                (response: AxiosResponse<ReqType.TypeEvent[]>) => {
                    return response.data;
                }
            )
        );
    }

    /**
     * retourne le type d'evenement par defaut
     * @returns {TypeEvent}
     */
    public getDefaultTypeEvent(): ReqType.TypeEvent {
        const retVal: ReqType.TypeEvent = {
            id: -1,
            nom_type: '',
        };
        return retVal;
    }
}


// WEBPACK FOOTER //
// ./src/services/TypeEventService.tsx